import { cn } from "@/utils";

/**
 * Skeleton — adopted from shadcn. A loading placeholder block. Consumes `--accent` and shapes
 * itself entirely from the className you pass (height/width/radius).
 */
function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("bg-accent animate-pulse rounded-md", className)}
      {...props}
    />
  );
}

export { Skeleton };
